export const PageTitle = ({ title, subtitle }: { title: string, subtitle: string }) => {
  return (
    <div>
      <h1 className='text-[22px] font-[500] leading-[130%]'>
        {title}
      </h1>
      {/* grey40 (#6A6E6E) instead of grey50: 4.5:1 minimum contrast (WCAG 1.4.3, audit Tax summary_B17) */}
      <p className='text-[13px] font-[400] leading-[150%] text-grey40'>
        {subtitle}
      </p>
    </div>
  )
}

